<label class="d-flex">
  <select class="dependency-versions" (change)="changeVersion($any($event.target).value)">
    <option [value]="item" *ngFor="let item of versions" [selected]="version === item">{{ item }}</option>
  </select>
  <span class="dependency-version">{{ version }}</span>
</label>
